import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OrderFormSubmission, OrderFormSubmissionField } from '../core/order-form-submission';

@Component({
  styleUrls: ['./order-form-submission-dialog.component.scss'],
  template: `
    <h2 mat-dialog-title>Order Form Response</h2>
    <mat-dialog-content>
      @for (field of sortedCommonFields(); track field) {
        <div class="common-field">
          <ng-container [ngTemplateOutlet]="fieldTemplate" [ngTemplateOutletContext]="{ field: field }"></ng-container>
        </div>
      }
      @for (field of orderFormSubmission.customFields; track field) {
        <div class="custom-field">
          <ng-container [ngTemplateOutlet]="fieldTemplate" [ngTemplateOutletContext]="{ field: field }"></ng-container>
        </div>
      }
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button color="primary" (click)="dialogRef.close()">Close</button>
    </mat-dialog-actions>
    
    <ng-template #fieldTemplate let-field="field">
      <span class="field-id">{{ field.label }}</span>
      <span class="field-answer">
        @switch (field.field_type) {
          @case ('file') {
            <span>
              @for (answer of parseIntoArray(field.answer); track answer) {
                <a [href]="answer.url" class="file-link" target="_blank">
                  {{ getFileName(answer) }}
                </a>
              }
            </span>
          }
          @case ('checkbox') {
            <span>{{ checkboxAnswer(field.answer) }}</span>
          }
          @case ('dropdown') {
            <span>{{ dropdownAnswer(field.answer) }}</span>
          }
          @case ('vbcuser') {
            <span>{{ dropdownAnswer(field.answer) }}</span>
          }
          @default {
            <span>{{ field.answer }}</span>
          }
        }
      </span>
    </ng-template>
    `,
  standalone: false,
})
export class OrderFormSubmissionDialogComponent {
  orderFormSubmission: OrderFormSubmission;

  constructor(public dialogRef: MatDialogRef<OrderFormSubmissionDialogComponent>) {}

  sortedCommonFields(): OrderFormSubmissionField[] {
    if (!this.orderFormSubmission) {
      return [];
    }

    return this.orderFormSubmission.commonFields.sort((first, second) => {
      return first.label >= second.label ? 1 : -1;
    });
  }

  dropdownAnswer(answer: any): string {
    if (typeof answer === 'string') {
      answer = JSON.parse(answer);
    }
    if (answer && answer.label) {
      try {
        const inner_answer = JSON.parse(answer.label);
        if (inner_answer != null && inner_answer.email) {
          return inner_answer.firstName + ' ' + inner_answer.lastName + ' (' + inner_answer.email + ')';
        } else {
          return answer.label;
        }
      } catch (e) {
        return answer.label;
      }
    }
    if (Array.isArray(answer) && answer.length > 0 && answer[0].label) {
      answer = answer.map((a) => a.label).join(', ');
    }
    return answer;
  }

  checkboxAnswer(answer: boolean): string {
    return answer ? 'Yes' : 'No';
  }

  getFileName(url: string | { name: string }): string {
    if (typeof url === 'string') {
      if (url.indexOf('/') >= 0) {
        return url.substring(url.lastIndexOf('/') + 1, url.length);
      }
      return url;
    }
    return url.name;
  }

  parseIntoArray(urlArray: any[] | string): any[] {
    if (urlArray instanceof Array) {
      return urlArray;
    }
    return JSON.parse(urlArray.toString());
  }
}
